"use strict";
exports.__esModule = true;
/**
 * Serialize a `bigint` to a string
 */
exports["default"] = {
    type: 'BigInt',
    shouldTransform: function (_type, obj) {
        return typeof obj === 'bigint';
    },
    toSerializable: function (value) {
        return value + "n";
    },
    fromSerializable: function (data) {
        return BigInt(data.slice(0, -1));
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQmlnSW50LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL1RyYW5zZm9ybS9CaWdJbnQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQTs7R0FFRztBQUNILHFCQUFlO0lBQ2IsSUFBSSxFQUFFLFFBQVE7SUFDZCxlQUFlLEVBQWYsVUFBZ0IsS0FBVSxFQUFFLEdBQVE7UUFDbEMsT0FBTyxPQUFPLEdBQUcsS0FBSyxRQUFRLENBQUE7SUFDaEMsQ0FBQztJQUNELGNBQWMsRUFBZCxVQUFlLEtBQWE7UUFDMUIsT0FBVSxLQUFLLE1BQUcsQ0FBQTtJQUNwQixDQUFDO0lBQ0QsZ0JBQWdCLEVBQWhCLFVBQWlCLElBQVk7UUFDM0IsT0FBTyxNQUFNLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxDQUFDLEVBQUUsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFBO0lBQ2xDLENBQUM7Q0FDRixDQUFBIn0=